import { ValueOf } from '../types/helper.type';

export const PlayerClipTypes = {
  ZolaClip: 'zolaClip',
  External: 'external',
  Custom: 'custom',
} as const;

export type PlayerClipType = ValueOf<typeof PlayerClipTypes>;
